import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/types/api';
import { useAuthStore } from '@/stores/auth.store';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: (failureCount, error) => {
        // Never retry auth/validation errors; retry transient ones once.
        if (error instanceof ApiError && error.code >= 400 && error.code < 500) {
          return false;
        }
        return failureCount < 1;
      },
      // A POS terminal is always focused — surprise refetches hurt UX.
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

/**
 * Cached answers belong to the account that fetched them. Several cashiers share
 * one till, so without this the next login saw the previous cashier's data until
 * it went stale — their shift status and finance float, their own orders, their
 * shift summary. Empty the cache whenever the signed-in user changes (sign-out
 * included); a reload of the same session keeps it.
 */
let cachedForUserId: string | null = useAuthStore.getState().user?.id ?? null;
useAuthStore.subscribe((state) => {
  const userId = state.user?.id ?? null;
  if (userId === cachedForUserId) return;
  cachedForUserId = userId;
  queryClient.clear();
});
